import React from 'react';
interface LogoProps {
  className?: string;
  animated?: boolean;
}
export function Logo({
  className = '',
  animated = false
}: LogoProps) {
  return <svg className={`h-10 w-auto ${className}`} viewBox="0 0 440 100" xmlns="http://www.w3.org/2000/svg" aria-label="Arrive Psychotherapy & Wellness Logo" data-id="element-117">
      {/* Path graphic */}
      <path d="M 10,70 Q 50,10 100,40 T 190,20" stroke="#7da8a0" strokeWidth="3" fill="none" className={animated ? 'animate-draw-path' : ''} strokeDasharray={animated ? '1000' : 'none'} strokeDashoffset={animated ? '1000' : '0'} data-id="element-118" />

      {/* Dot at end of path */}
      <circle cx="190" cy="20" r="5" fill="#d4a574" data-id="element-119" />

      {/* "ARRIVE" text */}
      <text x="310" y="50" fontFamily="Montserrat, sans-serif" fontWeight="500" fontSize="40" fill="#4a7272" letterSpacing="2" textAnchor="middle" data-id="element-120">
        ARRIVE
      </text>

      {/* "PSYCHOTHERAPY & WELLNESS" subtitle - centred below ARRIVE */}
      <text x="310" y="72" fontFamily="Montserrat, sans-serif" fontWeight="300" fontSize="11" fill="#4a7272" letterSpacing="2.5" textAnchor="middle" data-id="element-121">
        PSYCHOTHERAPY &amp; WELLNESS
      </text>
    </svg>;
}